(function(d, s, id) {
              var js, fjs = d.getElementsByTagName(s)[0];
              if (d.getElementById(id)) return;
              js = d.createElement(s); js.id = id;
              js.src = "//connect.facebook.net/en_US/all.js#xfbml=1&appId=353072448079846";
              fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', 'facebook-jssdk'));


window.twttr = (function(d, s, id) {
  var js, fjs = d.getElementsByTagName(s)[0],
    t = window.twttr || {};
  if (d.getElementById(id)) return t;
  js = d.createElement(s);
  js.id = id;
  js.src = "https://platform.twitter.com/widgets.js";
  fjs.parentNode.insertBefore(js, fjs);
 
  t._e = [];
  t.ready = function(f) {
    t._e.push(f);
  };
 
  return t;
}(document, "script", "twitter-wjs"));

$(document).ready(function(){
  
  if( $('.article-side-bar').length > 0){ 
    
    var fixed = $('.article-side-bar');
	var offsetTop  = fixed.offset().top;
	var fixed_height = fixed.height();
  
    window.addEventListener('scroll',function(){
      var screen_width = $(window).width();
      var scrollPost = $(window).scrollTop();
      var stop_scroll_point = $('section.index-module').offset().top;
      stop_scroll_point = stop_scroll_point - fixed_height - 140;



      if((scrollPost + 70) > offsetTop && screen_width > 972 && scrollPost < stop_scroll_point){
          fixed.addClass('fixed-blog-form');
      }else{
          fixed.removeClass('fixed-blog-form');
      }

    }); 
  }
  
  var current_URL = encodeURI(window.location);
  
  
  
  $('.subscription-learnmore').click(function () {   
     //Call hotjar
     hj('vpv', '/article-subscription-learn-more/');           
  });

  $(".article__content blockquote").each(function(){
  
    var tw_content = $(this).text();
    tw_content = tw_content.replace('Tweet It!','');
    tw_content = encodeURI(tw_content);
    //var res = tw_content.split(" - ");
	console.log(tw_content);
    
    var href = 'https://twitter.com/intent/tweet?source=webclient&text='+tw_content+'&via=holstee';
  	$(this).find('.twitter-share-button').attr('href',href);
  
  });
  
  /*
    $(window).scroll(function() {
      var scrollHeight = $(document).height();
      var scrollPosition = $(window).height() + $(window).scrollTop();

      if ((scrollHeight / 2) < scrollPosition) {
          $('div.klaviyo_flyout_k3mHQf').css('display','block');
      }      

    });
*/
  
  /* js for redirection to same article after user logged in -- only for block articles */
  $('#loginToArticle').on('click',function(){
    var pathname   = window.location.pathname; // Returns path only
    var urlname    = window.location.href;     // Returns full URL

    if(pathname.indexOf("blogs/mindful-matter/") > -1){
      localStorage.setItem("articlePath", urlname);
    }
  })
  
  
});

var url = window.location.href;
url = url.replace('https','http');


var data = 'https://graph.facebook.com/?id='+url;      
      
$.ajax({ 
    type: 'GET', 
    url: data, 
    async: false,
    contentType: "application/json", 
    dataType: 'jsonp', 
    success: function(r) {      
        
      var total_comments = 0;
      var str_comments = ' Comments';
      
      if(r.comments){
      	total_comments = r.comments;
      }
      
      if(total_comments == 1){
      	str_comments = ' Comment';
      }
      
      $('#count-current-comments-fb').html(total_comments + str_comments);
                
    }, 
    error: function(e) { 
    }

});
